import { getVueTemplate } from "../../_imports/utils/utils.common";
import FormsBaseMultiCheckboxField from "./_imports/forms-base-multi-checkbox-field.vue";

export default {
	name: 'forms-event-sessions-field',
	template: getVueTemplate('forms-event-sessions-field'),
	mixins: [
		FormsBaseMultiCheckboxField
	],
	data() {
		return {
			innerFields: [],
			innerUserInput: [],
			validSessions: []
		}
	},
	created() {
		this.ignore = !this.field.sessions || !this.field.sessions.length;

		if (this.field.sessions) {
			this.validSessions = this.field.sessions.filter(session => Date.now() < new Date(session.startDate || session.displayDate));
		}
	},
	methods: {
		createCheckboxFieldFromSession(session) {
			return {
				id: this.getRandomId('session-'),
				label: session.title,
				name: session.id,
				value: session.title
			}
		},
		getSessionLabel(session) {
			return `${session.title} - ${session.displayDate} ${session.displayTime}`;
		}
	}
};